import type { UserSubscriptionPlanEnum } from "~/solidJs/shared/helpers/types";
import type { StyledSelect } from "~/solidJs/shared/ui/molecules/Select";

export enum UpgradePeriod {
	FromNewBillingPeriod = "from_new_billing_period",
	FromNextMonth = "from_next_month",
	Immediately = "immediately"
}

export interface ChangeSubscriptionPeriod extends StyledSelect.SelectClosedItem {
	value: UpgradePeriod;
	description: string;
	chargeDescription: string;
	successDescription: string;
}

export interface ConfirmPlanChangeState {
	plan: UserSubscriptionPlanEnum;
	selectedPeriod: ChangeSubscriptionPeriod;
}

export interface ConfirmPlanChangeModalData {
	plan: UserSubscriptionPlanEnum;
	mode: "upgrade" | "downgrade";
}

const END_BILLING_PERIOD: ChangeSubscriptionPeriod = {
	value: UpgradePeriod.FromNewBillingPeriod,
	label: "Change at the end of billing period",
	description: "You will receive credits from new plan at the end of billing period",
	chargeDescription: "will be charged at billing period end",
	successDescription: "Your plan will change at the end of the billing period."
};

const NEXT_MONTH: ChangeSubscriptionPeriod = {
	value: UpgradePeriod.FromNextMonth,
	label: "Change at the end of billing month",
	description: "You will receive credits from new plan at the end of billing month",
	chargeDescription: "will be charged next month",
	successDescription: "Your plan will change at the end of the billing month."
};
const IMMIDIATE_CHANGE: ChangeSubscriptionPeriod = {
	value: UpgradePeriod.Immediately,
	label: "Change now",
	description: "You will receive credits from your new subscription instantly",
	chargeDescription: "will be charged today",
	successDescription: "Your plan will change immediately."
};

export const SUBSCRIPTION_UPGRADE_PERIODS: ChangeSubscriptionPeriod[] = [
	END_BILLING_PERIOD,
	NEXT_MONTH,
	IMMIDIATE_CHANGE
];

export const SUBSCRIPTION_DOWNGRADE_PERIODS: ChangeSubscriptionPeriod[] = [
	END_BILLING_PERIOD,
	NEXT_MONTH
];
